import { Loading } from 'components/loading/Loading';
import QRCodeGenerator from 'components/QRCodeGenerator';
import React, { useEffect, useState } from 'react';
import { fetchOrderIdsInPickPackList } from 'services';
import { baseURL, showError } from 'utils';
import styles from './index.module.scss';

const bodyStyles = `
  #sidenav {
    display: none !important;
  }
  #sidenav-toggle {
    display: none !important;
  }
`;

const QRCodes = props => {
  const { pickPackId } = props.match.params;
  const [loading, setLoading] = useState<boolean>(false);
  const [orderIds, setOrderIds] = useState<string[]>([]);

  const fetchPickPackOrders = async () => {
    setLoading(true);
    try {
      const response = await fetchOrderIdsInPickPackList(pickPackId);
      setOrderIds(response);
      setTimeout(() => window.print(), 200);
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const style = document.createElement('style');
    style.textContent = bodyStyles;
    document.head.append(style);
    fetchPickPackOrders();
  }, []);

  const getQRCodeURLs = () => orderIds.map(id => `${baseURL}/orders/${id}`);

  if (loading) return <Loading />;

  return (
    <div id={'qr-codes-container'} className={styles['qr-codes-container']}>
      <QRCodeGenerator
        qrCodeURLs={getQRCodeURLs()}
      />
    </div>
  );
};

export default QRCodes;